enum FileSelectionFilter {
    None,
    Images,
}

export default FileSelectionFilter;
